import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import request from '@/utils/request'
import auth from '@/utils/auth'

import ViewUI from 'view-design';
// import style
import 'view-design/dist/styles/iview.css'
import '@/assets/common.css'    // 使用 CSS

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import GeminiScrollbar from 'vue-gemini-scrollbar'
Vue.use(GeminiScrollbar)

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

Vue.config.productionTip = false
Vue.use(ViewUI)

// Vant
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)
import { Lazyload } from 'vant'
Vue.use(Lazyload)

const authH5 = async () => {
  if (store.state.openId) {
    return
  }
  await auth.wxAuthorize()
}



const init = async () => {
  await authH5()
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app')
}
init()
